import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { add_admin } from '../api/adminsApi'
import { toast } from 'react-toastify'
import { ChangeEvent, useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { AddAdminInterface, RoleListInterface, addAdminInitValues } from '../../../modules/accounts/components/settings/SettingsModel'
import * as Yup from 'yup'
import { get_active_roles, get_all_roles } from '../../roles/api/rolesApi'
import { validateImage } from '../../../helper-functions/ImageValidation'

const adminSchema = Yup.object().shape({
    first_name: Yup.string().required("First Name is required"),
    role:Yup.string().required("Role is required"),
    email: Yup.string()
        .required('Email is required')
        .matches(/^[A-Za-z0-9._%+-]+@([A-Za-z0-9.-]+\.[A-Za-z]{2,4})$/, 'Invalid email address'),
})
function AddAdmin() {
    const [roleList, setRoleList] = useState<RoleListInterface[]>([]);
    const [loading, setLoading] = useState(false)
    const [userPicture, setUserPicture] = useState<File | null>(null);
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const { data, isLoading, isError } = useQuery('roles', get_active_roles, { refetchOnWindowFocus: false });
        useEffect(() => {
          if (data) {
            setRoleList(data.data)
          }
        }, [data]);
        const mutation = useMutation(add_admin, {
            onSuccess: (data) => {
                toast.success(data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                });
                navigate('/admins/admins-list');
                setLoading(false);
                queryClient.invalidateQueries('admins');
            },
            onError: (error:any) => {
                const errorMessage = error.response?.data?.message || 'Something went wrong';
                toast.error(errorMessage, {
                    position: 'top-right',
                    autoClose: 3000,
                });
                setLoading(false);
            },
        });
    const formik = useFormik<AddAdminInterface>({
        initialValues: addAdminInitValues,
        validationSchema: adminSchema,
        onSubmit: (values) => {
            setLoading(true)
                  // Create a FormData object
      const formData = new FormData();
            formData.append('first_name', values.first_name);
      formData.append('last_name', values.last_name);
      formData.append('email', values.email);
      formData.append('role', values.role);
      if (userPicture) {
        formData.append('profile_picture', userPicture);
      };
            mutation.mutate(formData)
        },
    })
    const handleImageChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        logoType: string,
        MAX_FILE_SIZE: number,
        ALLOWED_TYPES: string[],
        MAX_DIMENSIONS: { [key: string]: { width: number; height: number } }
      ) => {
        const newFile = e.target.files?.[0];
        if (newFile) {
          // Call the validation function
          validateImage(
            newFile,
            logoType,
            (validFileUrl) => {
              // If valid, update the state with the image URL
              if (logoType === 'picture') {
                setUserPicture(newFile);
              }
            },
            MAX_FILE_SIZE, // File size limit in MB
            ALLOWED_TYPES, // Allowed file types
            MAX_DIMENSIONS // Maximum dimensions per logo type
          );
        }
      };
    return (
        <div className='card mb-5 mb-xl-10'>
            <div
                className='card-header border-0'
            >
                <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Add Admin</h3>
                </div>
            </div>
            <div id='kt_account_profile_details' className='collapse show'>
                <form onSubmit={formik.handleSubmit} noValidate className='form'>
                    <div className='card-body border-top p-9'>
                    <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Role</span>
            </label>
                            <div className='col-lg-8 fv-row'>
                                <select
                                    className='form-select form-select-solid form-select-lg fw-bold'
                                    {...formik.getFieldProps('role')}
                                >
                                    <option value=''>Select a Role...</option>
                                    {Array.isArray(roleList) && roleList.map((rolType) => (
                                        <option key={rolType.id} value={rolType.name}>
                                            {rolType.name}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.role && formik.errors.role && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>{formik.errors.role}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>First Name</label>
                            <div className='col-lg-8 fv-row'>
                                <input
                                    type='text'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder="First Name"
                                    {...formik.getFieldProps('first_name')}
                                />
                                {formik.touched.first_name && formik.errors.first_name && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>{formik.errors.first_name}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Last Name</label>
                            <div className='col-lg-8 fv-row'>
                                <input
                                    type='text'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder="Last Name"
                                    {...formik.getFieldProps('last_name')}
                                />
                            </div>
                        </div>
                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                <span className='required'>Email</span>
                            </label>
                            <div className='col-lg-8 fv-row'>
                                <input
                                    type='email'
                                    className='form-control form-control-lg form-control-solid'
                                    placeholder="Email"
                                    {...formik.getFieldProps('email')}
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>{formik.errors.email}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>Picture</label>
            <div className='col-lg-8 fv-row'>
              <input
                type='file'
                className='form-control form-control-lg form-control-solid'
                onChange={(e) => handleImageChange(
                    e,
                    'picture',
                    2, // Max file size (2MB)
                    ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                    {
                      picture: { width: 200, height: 200 }
                    } // Max dimensions
                  )}
                  accept="image/jpeg, image/jpg, image/png"
                name='picture'
              />
              <div className='text-danger mt-2'>
                Recommended size: 200 x 200 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
                </div>
            </div>
          </div>
                    </div>
                    <div className='card-footer d-flex justify-content-end py-6 px-9'>
                        <button
                            data-toggle="tooltip" data-placement="bottom" title="Navigate to Admin List"
                            className='btn btn-light-dark mx-3'
                            onClick={() => navigate('/admins/admins-list')}
                        >
                            Cancel
                        </button>
                        <button data-toggle="tooltip" data-placement="bottom" title="Add Admin" type='submit' className='btn btn-primary' disabled={loading}>
                            {!loading && 'Add Admin'}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddAdmin